import { render, staticRenderFns } from "./PatrolImages.vue?vue&type=template&id=37fdd186&scoped=true&"
import script from "./PatrolImages.vue?vue&type=script&lang=js&"
export * from "./PatrolImages.vue?vue&type=script&lang=js&"
import style0 from "./PatrolImages.vue?vue&type=style&index=0&id=37fdd186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fdd186",
  null
  
)

export default component.exports